import(/* webpackMode: "eager" */ "/vercel/path0/apps/admin/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AgentBanner"] */ "/vercel/path0/apps/admin/components/AgentBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/apps/admin/components/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/admin/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
